import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import logo from '../assets/images/logo.png';
// import menu1 from '../assets/images/menuImg1.png';
import menu2 from '../assets/images/menuImg2.png';
import menu3 from '../assets/images/menuImg3.png';
import submenu from '../assets/images/subMenuImg.png';
const Sidebar = () => {
	const location = useLocation();

	return (
		<div className='sidebar'>
			<div className='logoSection'>
				<Link to='/'>
					<img src={logo} className='logoImg' alt='logo' />
				</Link>
			</div>
			<div className='menuSection'>
				<ul className='menuUl'>
					{/* <li>
            <Link to='/#' className={location.pathname === '/' ? 'active' : ''}>
              <img src={menu1} className='dashBoardImg' alt='imgForSidebar' />{' '}
              Dashboard{' '}
            </Link>
          </li> */}
					<li>
						<Link className={location.pathname === '/' ? 'active' : ''} to='/'>
							<img src={menu2} className='dashBoardImg' alt='imgForSidebar' />{' '}
							Group Info{' '}
						</Link>
					</li>
					<li>
						<Link to='' onClick={(e) => e.preventDefault()}>
							<img src={menu3} className='dashBoardImg' alt='imgForSidebar' />{' '}
							Settings{' '}
						</Link>

						<ul className='subMenu'>
							<li>
								<Link
									to='/webhook-settings'
									className={
										location.pathname === '/webhook-settings' ? 'active' : ''
									}
								>
									<img
										src={submenu}
										className='dashBoardImg'
										alt='imgForSidebar'
									/>{' '}
									Webhook Settings{' '}
								</Link>
							</li>
							<li>
								<Link
									to='/sheet-settings'
									className={
										location.pathname === '/sheet-settings' ? 'active' : ''
									}
								>
									<img
										src={submenu}
										className='dashBoardImg'
										alt='imgForSidebar'
									/>{' '}
									Sheet Settings{' '}
								</Link>
							</li>
							{/* <li>
                <Link to='/#'>
                  <img
                    src='images/subMenuImg.png'
                    className='dashBoardImg'
                    alt='imgForSidebar'
                  />{' '}
                  Message Settings{' '}
                </Link>
              </li> */}
							<li>
								<Link
									to='/api-settings'
									className={
										location.pathname === '/api-settings' ? 'active' : ''
									}
								>
									<img
										src={submenu}
										className='dashBoardImg'
										alt='imgForSidebar'
									/>{' '}
									API Settings{' '}
								</Link>
							</li>
							<li>
								<Link to='/message-settings'>
									<img
										src='images/subMenuImg.png'
										className='dashBoardImg'
										alt='imgForSidebar'
									/>{' '}
									Message Settings
								</Link>
							</li>
							{/* <li>
                <Link to='/#'>
                  <img
                    src='images/subMenuImg.png'
                    className='dashBoardImg'
                    alt='imgForSidebar'
                  />{' '}
                  Webhook{' '}
                </Link>
              </li> */}
						</ul>
					</li>
				</ul>
			</div>
		</div>
	);
};

export default Sidebar;
